import downloadFile from '@common/utils/downloadFile';
import HandleResponses from '../../../../../common/utils/handleResponses';
import axios from '../../../axios';
import optimaAxios from '../../../tms-optima-axios';

const actions = {
  async downloadReport(_, { params, report }) {
    try {
      let instance;
      switch (report.apiInstance) {
        case 'optima':
          instance = optimaAxios;
          break;
        default:
          instance = axios;
      }
      const result = await instance({ url: `${report.apiUrl}`,
        method: 'GET',
        responseType: 'blob',
        params,
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const now = new Date().toISOString();
        downloadFile(document, url, `${report.reportName}-${now}.xlsx`);
      }
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async emailReport(_, { params, report }) {
    try {
      const result = await axios({ url: `${report.apiUrl}`,
        method: 'GET',
        params,
      });
      return result;
    } catch (error) {
      return error;
    }
  },

  async reportsConfig({ commit }) {
    try {
      const result = await axios({ url: 'report-v2/config',
        method: 'GET',
      });
      const config = result.data
        && result.data.report_configuration
        && result.data.report_configuration.shipper_reports;
      commit('SET_REPORTS', config);
      return config;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async getReportList({ commit }) {
    try {
      const result = await axios({ url: 'report-v2/list',
        method: 'GET',
      });
      const list = result.data && result.data;
      commit('SET_TRIGGERED_REPORTS', list);
      return list;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

};

export default actions;
